import type { AdminUser } from '../../services/admin'

export type AdminUserStatus = 'active' | 'pending' | 'deactivated'

export function adminUserStatus(
  user: Pick<AdminUser, 'isActive' | 'passwordReady'>
): AdminUserStatus {
  if (!user.isActive) return 'deactivated'
  if (!user.passwordReady) return 'pending'
  return 'active'
}

export function adminUserStatusLabel(status: AdminUserStatus): string {
  switch (status) {
    case 'active':
      return 'Aktiv'
    case 'pending':
      return 'Invitation sendt'
    case 'deactivated':
      return 'Deaktiveret'
  }
}
